import { liteClient } from "algoliasearch/lite";
import { debounce } from "./util";

import template from "../lib/micro-template";

const TEMPLATE_ID = "auto-suggest-list";

const KEYUP_TIMEOUT = 400;

const hideSuggestionsOnClickOutside = (listElm) => {
  document.addEventListener("click", (event) => {
    if (listElm.contains(event.target)) {
      return;
    }
    listElm.innerHTML = "";
  });
};

const hideSuggestionsOnFocusOut = (listElm) => {
  const lastFocusableItem = listElm.querySelector("li:last-child a");
  if (!lastFocusableItem) {
    return;
  }
  lastFocusableItem.addEventListener("focusout", (event) => {
    listElm.innerHTML = "";
  });
};

const renderSuggestions = (listElm, inputElm, id) => (suggestions) => {
  listElm.innerHTML = template(TEMPLATE_ID, { suggestions });
  const listTitle = listElm.querySelector("h3");
  listTitle.setAttribute("id", `auto-suggest-title-${id}`);
  listElm
    .querySelector("ul")
    .setAttribute("aria-labelledby", `auto-suggest-title-${id}`);
  inputElm.setAttribute("aria-expanded", suggestions.length !== 0);

  hideSuggestionsOnFocusOut(listElm);
};

const autoSuggest = (listElm, inputElm, id, algolia) => (e) => {
  const query = e.target.value;

  const searchClient = liteClient(
    algolia.algoliaAppId,
    algolia.algoliaApiKey
  );

  if (query.length === 0) return;

  searchClient
    .search({
      requests: [{
        indexName: algolia.algoliaResultsIndex,
        query,
        hitsPerPage: 5,
        restrictSearchableAttributes: ["name"],
      },
      {
        indexName: algolia.algoliaWordsIndex,
        query,
        hitsPerPage: 1,
        restrictSearchableAttributes: ["name"],
      }],
  })
  .then(({ results }) => {
    const hits = [results[1].hits[0], results[0].hits]
      .flat()
      .slice(0, 5)
      .filter(a => a);
    renderSuggestions(listElm, inputElm, id)(hits);
  });
};

export const enhancer = (form) => {
  const inputElm = form.querySelector(".js-auto-suggest-input");
  const listElm = form.querySelector(".js-auto-suggest-list");
  const id = inputElm.getAttribute("id");

  const algoliaAppId = form.getAttribute("data-algolia-application-id");
  const algoliaApiKey = form.getAttribute("data-algolia-app-key");
  const algoliaResultsIndex = form.getAttribute("data-algolia-results-index");
  const algoliaWordsIndex = form.getAttribute("data-algolia-words-index");
  form.removeAttribute("data-algolia-application-id");
  form.removeAttribute("data-algolia-app-key");
  form.removeAttribute("data-algolia-results-index");
  form.removeAttribute("data-algolia-words-index");

  if (!algoliaAppId || !algoliaApiKey || !algoliaResultsIndex || !algoliaWordsIndex) return;

  inputElm.addEventListener(
    "keyup",
    debounce(
      autoSuggest(
        listElm,
        inputElm,
        id,
        {algoliaAppId, algoliaApiKey, algoliaResultsIndex, algoliaWordsIndex }
      ), KEYUP_TIMEOUT),
  );
  hideSuggestionsOnClickOutside(listElm);
};
